import axios from "axios"

const URL_DISCORD = "https://servidorrotinacurl.rj.r.appspot.com/discord/enviarMsgDiscord"

/**
 * Envia uma mensagem para o Discord (não bloqueia o fluxo; erros são ignorados).
 * @param {{ grupo: string, titulo: string, msg: string }} payload
 */
export function enviarMsgDiscord({ grupo, titulo, msg }) {
	axios
		.post(URL_DISCORD, { grupo, titulo, msg })
		.catch(() => {
			// Ignora erros do Discord para não quebrar o fluxo
		})
}

/**
 * Formata e envia o erro de "salvar imagem no CDN" para o Discord.
 * Reutilizável em useGallery e useCamera (e em qualquer outro lugar com mesmo formato de erro).
 * @param {Object} erroInfo - Objeto com method, url, retorno, data (ex.: idProf, imagem)
 */
export function enviarErroCDNDiscord(erroInfo) {
	const msgDiscord = `
**Erro ao salvar imagem no CDN**
**Método:** ${erroInfo.method}
**URL:** ${erroInfo.url}
**ID Profissional:** ${erroInfo.data?.idProf ?? "N/A"}
**Retorno:** ${JSON.stringify(erroInfo.retorno, null, 2)}
**Timestamp:** ${new Date().toLocaleString("pt-BR")}
**JSON Enviado:** ${JSON.stringify(erroInfo.data, null, 2)}
`
	enviarMsgDiscord({
		grupo: "rotina",
		titulo: "> Erro ao enviar para o CDN",
		msg: msgDiscord,
	})
}
